import React from 'react'
import { Link } from 'react-router-dom';
import { trackSharePop } from '../../Utils/blogs'



const MyRewards = (props) => {
	const { availableCodeCount, email, visitorId } = props;
	const onDiscountPage = () => {
		trackSharePop(email, visitorId, 'discount-page')
	}
	return (
		<div className="panel-card-container my-rewards-card-container">
			<div className="rewards-summary-card rewards-summary-card-loaded">
				<div className="card-list-container no-border">
				<Link to="/my-reward" onClick={ onDiscountPage }>
					<div className="card-list-item-container no-image">
						<button className="card-list-item " aria-label="Your rewards">
							<div className="card-list-item-content">
								<div className="list-item-text-wrapper">
									<div className="list-item-title">Your rewards</div>
									<div className="list-item-subtitle text-muted">You have <span className="coupon-count">{availableCodeCount}</span> reward available</div>
								</div>
							</div>
							<div className="chevron right"></div>
						</button>
					</div>
					</Link>
				</div>
			</div>
		</div>

	)
}

export default MyRewards;